/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

import * as shape from "d3-shape";
import {IErrorObject} from "../../../../../types/platform/universe";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {MessageDialogComponent} from "../../base/components/message-dialog/message-dialog.component";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-polar",
	templateUrl: "./polar.component.html",
	styleUrls: ["../floating/floating.component.css", "./polar.component.css"],
})
export class PolarComponent extends FloatingComponent implements OnChanges, OnInit {

	@Input() public locked: boolean;
	@Input() public size: number[] = [100, 100];
	@Input() public shots: any[];

	@Input() public unit: string;

	public title: string = "Polar";

	public progress = false;

	public dataSource: any[];

	// options
	public animations: boolean = true;
	public xAxisLabel: string = "";
	public yAxisLabel: string = "";

	@Output() public progrssChange = new EventEmitter<boolean>();

	public colorScheme = {
		domain: ["#1CBCD8", "#FF8D60", "#FF586B", "#5c6bc0", "#3d5afe", "#4caf50", "#673ab7"],
	};

	public LineInterpolation = shape.curveLinearClosed;

	constructor(
		protected matDialog: MatDialog,
		protected snackbar: MatSnackBar,
		private router: Router,
		public translate: TranslateService
	) {
		super();
	}

	private messageDialog(title: string, message: string, code: string, callback: (result: any) => void = (result:any) => {}): void {
		const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
			width: "30%",
			minWidth: "320px",
			height: "fit-content",
			data: {content: {title: "", message: message}},
			disableClose: true,
		});

		dialog.afterClosed().subscribe((result: any): void => {
			callback(result);
		});
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(error: IErrorObject, callback: (result: any) => void = (error:IErrorObject) => {}): void {
		if (error) {
			if (error.code === 1) {
				this.router.navigate(['/']);
			} else {
				const dialog: MatDialogRef<any> = this.matDialog.open(MessageDialogComponent, {
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {content: {title: "Error.", message: error.message, tag: error.tag}},
					disableClose: true,
				});

				dialog.afterClosed().subscribe((result: any): void => {
					callback(result);
				});
			}
		}
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "visible":
				case "shots":
					if (this.visible) {
						this.draw(this.shots);
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.xAxisLabel = this.unit;
		this.initLayout();
	}

	/**
	 * @returns none
	 */
	public initLayout(): void {
		this.size = [100, 100];
	}

	/**
	 * @returns none
	 */
	public enter(): void {
		this.size = [200, 200];
	}

	/**
	 * @returns none
	 */
	public leave(): void {
		this.initLayout();
	}

	/**
	 * @returns none
	 */
	public draw(shots: any): void {
		this.Progress(true);
		try {
			if (shots) {
				const dataSource: any[] = [];
				shots.forEach((shot: any) => {
					const series: any[] = [];
					if (shot.prizm) {
						shot.prizm.DataList.forEach((data: any): void => {
							if (data.Unit === this.unit) {
								series.push({name: data.Name, value: data.Value});
							}
						});
					}
					dataSource.push({name: shot.name, series});
				});
				this.dataSource = dataSource;
			} else {
				// Todo: error code messege
			}
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}


